import { useState } from 'react';
import { BackLink, Header } from 'src/components';
import { usePlaylists, usePlaylistMutations } from 'src/features/AddToPlaylist';
import { PlaylistCard } from './PlaylistCard';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import styled from 'styled-components';

const Grid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  margin-top: 24px;
`;

export default function PlaylistsView() {
  const { data, isLoading } = usePlaylists();
  const { createPlaylist } = usePlaylistMutations();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const rows = data ?? [];

  return (
    <>
      <BackLink label="Twoja praktyka" to="/me/summary" />
      <Header title="Playlisty" as="h1" />
      <Button variant="contained" onClick={() => setOpen(true)} sx={{ mt: 2 }}>
        Utwórz playlistę
      </Button>
      {isLoading && <Typography variant="body2">…</Typography>}
      {!isLoading && !rows.length && (
        <Typography variant="body1" sx={{ mt: 3 }}>
          Nie masz jeszcze playlist. Dodaj pierwszą sesję z biblioteki.
        </Typography>
      )}
      <Grid>
        {rows.map((p) => (
          <PlaylistCard key={p.id} row={p} />
        ))}
      </Grid>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Nowa playlista</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nazwa"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Anuluj</Button>
          <Button
            variant="contained"
            disabled={!name.trim()}
            onClick={() => {
              void createPlaylist
                .mutateAsync({
                  name: name.trim(),
                  isPrivate: true,
                })
                .then(() => {
                  setName('');
                  setOpen(false);
                })
                .catch(() => {});
            }}
          >
            Utwórz
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
